module.exports = __webpack_public_path__ + "static/media/arrow-to-left.20dd9a21.svg";